module.exports = __webpack_public_path__ + "media/assets/home_images/banner1-d32813078741d34338d17afe5ca26c5e.png";